/* Simple markdown to HTML for AI responses */
function mdToHtml(md){
  if(!md)return"";
  let h=md.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  /* Headers */
  h=h.replace(/^####\s+(.+)$/gm,"<h4>$1</h4>");
  h=h.replace(/^###\s+(.+)$/gm,"<h3>$1</h3>");
  h=h.replace(/^##\s+(.+)$/gm,"<h3>$1</h3>");
  /* Bold & italic */
  h=h.replace(/\*\*\*(.+?)\*\*\*/g,"<strong><em>$1</em></strong>");
  h=h.replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>");
  h=h.replace(/\*(.+?)\*/g,"<em>$1</em>");
  /* Inline code */
  h=h.replace(/`([^`]+)`/g,"<code>$1</code>");
  /* Process lines for lists and paragraphs */
  const lines=h.split("\n");
  let out="";let inUl=false;let inOl=false;
  for(let i=0;i<lines.length;i++){
    const ln=lines[i];
    const ulMatch=ln.match(/^\s*[-•]\s+(.*)/);
    const olMatch=ln.match(/^\s*(\d+)[.)]\s+(.*)/);
    if(ulMatch){if(!inUl){if(inOl){out+="</ol>";inOl=false;}out+="<ul>";inUl=true;}out+="<li>"+ulMatch[1]+"</li>";continue;}
    if(olMatch){if(!inOl){if(inUl){out+="</ul>";inUl=false;}out+="<ol>";inOl=true;}out+="<li>"+olMatch[2]+"</li>";continue;}
    if(inUl){out+="</ul>";inUl=false;}if(inOl){out+="</ol>";inOl=false;}
    if(ln.trim()===""){out+="";continue;}
    if(!ln.startsWith("<h")){out+="<p>"+ln+"</p>";}else{out+=ln;}
  }
  if(inUl)out+="</ul>";if(inOl)out+="</ol>";
  return out;
}

export default mdToHtml;
